// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(vehicle_category, geo_region) {
  if (vehicle_category !== 0) {
    return {
            title_text: "கம்ப்லீஷுன் ஸ்கோர்",
            learn_more_text: "மேலும் அறிந்துகொள்ள",
            info_btn_details: {
              video_url: undefined,
              question: "கம்ப்லீஷுன் ஸ்கோர் என்றால் என்ன?",
              answer: "உங்களுக்கு அனுப்பப்பட்ட கடைசி 50 ஆர்டர்களில் முடிக்கப்பட்ட மொத்த ஆர்டர்கள் மூலமாக கம்ப்லீஷுன் ஸ்கோர் கணக்கிடப்படுகிறது. \n\n                    எ.கா: போர்ட்டர் 50 ஆர்டர்களை வழங்கினால், நீங்கள் 40ஐ முடித்தால், கம்ப்லீஷுன் ஸ்கோர் 80% ஆகும்."
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVidTrucks(geo_region),
                question: "கம்ப்லீஷுன் ஸ்கோர் என்றால் என்ன மற்றும் அது ஏன் முக்கியமானது?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "எனது கம்ப்லீஷுன் ஸ்கோரை எவ்வாறு மேம்படுத்துவது?",
                answer: "அதிக கம்ப்லீஷுன் ஸ்கோர் பெற  அனைத்து ஆர்டர்களையும் ஏற்று முடிக்கவும்"
              },
              {
                video_url: undefined,
                question: "ஒரு நல்ல கம்ப்லீஷுன் ஸ்கோர் என எவ்வளவு கருதப்படும்?",
                answer: "அதிக வருமானம் ஈட்டும் போர்ட்டர் பார்ட்னர்கள் 90% அல்லது அதற்கு மேற்பட்ட கம்ப்ளீஷுன் ஸ்கோரைக் கொண்டுள்ளவர்கள்."
              },
              {
                video_url: undefined,
                question: "எனது கம்ப்லீஷுன் ஸ்கோரை ஏன் என்னால் பார்க்க முடியவில்லை?",
                answer: "ಸகுறைந்தபட்சம் 50 ஆர்டர்களைப் பெற்ற பார்ட்னர்களுக்கு மட்டுமே ஸ்கோர் கணக்கிடப்படும்."
              }
            ],
            locked_score_msg: "அதிக ஸ்கோர் பெற அதிக ஆர்டர்களை முடிக்கவும்",
            message_text: "அதிக கம்ப்லீஷுன் ஸ்கோர்  கொண்ட பார்ட்னர்கள் அதிக ஆர்டர்களைப் பெறுவதற்கான வாய்ப்புகள் அதிகம்."
          };
  } else {
    return {
            title_text: "கம்ப்லீஷுன் ஸ்கோர்",
            learn_more_text: "மேலும் அறிந்துகொள்ள",
            info_btn_details: {
              video_url: undefined,
              question: "கம்ப்லீஷுன் ஸ்கோர் என்றால் என்ன?",
              answer: "உங்களுக்கு ஒதுக்கப்பட்ட கடைசி 50 ஆர்டர்களில் முடிக்கப்பட்ட மொத்த ஆர்டர்களாக நிறைவு மதிப்பெண் கணக்கிடப்படுகிறது. ஆர்டர்கள் உங்களுக்கு பிங் செய்யப்பட்டன, ஆனால் உங்கள் ஸ்கோரில் நீங்கள் கணக்கிடப்படுவதற்கு முன்பு மற்றொரு ஓட்டுனரால் ஏற்றுக்கொள்ளப்பட்டது. \n\n                    எ.கா: போர்ட்டர் உங்களுக்கு 50 ஆர்டர்களை வழங்கினால், நீங்கள் 40ஐ முடித்தால், நிறைவு மதிப்பெண் 80%"
            },
            learn_more_btn_details: [
              {
                video_url: PartnerContentHelper.getV1InfoVid2w(geo_region),
                question: "கம்ப்லீஷுன் ஸ்கோர் என்றால் என்ன மற்றும் அது ஏன் முக்கியமானது?",
                answer: ""
              },
              {
                video_url: undefined,
                question: "எனது கம்ப்லீஷுன் ஸ்கோரை எவ்வாறு மேம்படுத்துவது?",
                answer: "அதிக கம்ப்லீஷுன் ஸ்கோர் பெற  அனைத்து ஆர்டர்களையும் ஏற்று முடிக்கவும்"
              },
              {
                video_url: undefined,
                question: "ஒரு நல்ல கம்ப்லீஷுன் ஸ்கோர் என எவ்வளவு கருதப்படும்?",
                answer: "அதிக வருமானம் ஈட்டும் போர்ட்டர் பார்ட்னர்கள் 90% அல்லது அதற்கு மேற்பட்ட கம்ப்ளீஷுன் ஸ்கோரைக் கொண்டுள்ளவர்கள்."
              },
              {
                video_url: undefined,
                question: "எனது கம்ப்லீஷுன் ஸ்கோரை ஏன் என்னால் பார்க்க முடியவில்லை?",
                answer: "ಸகுறைந்தபட்சம் 50 ஆர்டர்களைப் பெற்ற பார்ட்னர்களுக்கு மட்டுமே ஸ்கோர் கணக்கிடப்படும்."
              }
            ],
            locked_score_msg: "அதிக ஸ்கோர் பெற அதிக ஆர்டர்களை முடிக்கவும்",
            message_text: "அதிக கம்ப்லீஷுன் ஸ்கோர்  கொண்ட பார்ட்னர்கள் அதிக ஆர்டர்களைப் பெறுவதற்கான வாய்ப்புகள் அதிகம்."
          };
  }
}

export {
  getContent ,
  
}
/* No side effect */
